import React from 'react';

import { ListItem } from 'material-ui/List';

import ParseAvatar from '../../../components/ParseAvatar';

function InstructorListItem(props) {  
  const { item, onItemSelect } = props;

  return (
    <ListItem
      key={item.id}
      value={item.id}
      primaryText={item.get('fullName')}
      secondaryText={item.get('title')}
      leftAvatar={<ParseAvatar avatar={item.get('avatar')}/>}
      onClick={() => onItemSelect(item)}
    />
  );
}

export default InstructorListItem;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/InstructorListItem.js